import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../../constants'

const Header = styled.header`
    font-size: 1.9rem;
    padding: 1.9rem 2.3rem;
    margin: 0;
    font-weight: 600;
    position: relative;
`

const SubHeader = styled.header`
    background: ${colors.blue2};
    color: white;
    height: 60px;
    padding-top: 20px;
    padding-left: 2vw;
    width: 100vw;
`

const Tabs = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    padding-right: 1rem;
`

interface TabProps {
    active?: boolean;
    disabled?: boolean;
}

const Tab = styled(Link)<TabProps>`
    background: ${colors.white};
    border: 2px solid ${colors.blue2};
    border-bottom: 0;
    border-radius: 5px 5px 0 0;
    color: ${colors.blue};
    padding: 1rem 0rem;
    cursor: pointer;
    font-weight: 400;
    text-decoration: none;
    font-size: 15px;
    display: inline-block;
    width: 150px;
    text-align: center;

    :not(:last-child) {
        margin-right: 5px;
    }

    ${({ active }) => active && `
        background: ${colors.blue2};
        color: ${colors.white};
        font-weight: 600;
    `}

    ${({ disabled }) => disabled && `
        background: ${colors.white};
        border-color: ${colors.greylight};
        color: ${colors.greylight};
        cursor: not-allowed;
    `}

    img {
        margin-bottom: 3px;
        margin-right: 5px;
        width: 20px;

        ${({ active }) => active && `
            filter: brightness(5);
        `}


        ${({ disabled }) => disabled && `
            filter: grayscale(1) brightness(1.9);
        `}
    }
`

export { Header, SubHeader, Tab, Tabs }
